const iframe = document.querySelector('.game-iframe');

if (iframe) {
  window.addEventListener('message', ({ data }) => {
    if (data === 'home-click') {
      const url = iframe.getAttribute('data-redirect-url');

      if (url) {
        window.location.href = url;
      } else {
        window.location.reload();
      }
    }
  });
}
